<template>
  <div>
    <CSpinner v-show="loading" color="primary" size="sm" class="mb-2" />
    <CAlert v-show="SavingFailure && !loading" color="danger">
      Tallennus epäonnistui. Yritä uudelleen. Mikäli virhe toistuu, ota yhteyttä
      tuki@stonesaw.fi
    </CAlert>
    <h5>Tarkista koodi:</h5>
    <CInput v-model="id" :disabled="loading" class="mb-4"> </CInput>
    <CButton
      color="primary"
      :disabled="loading"
      class="mb-3"
      @click="findCode()"
      >Hae</CButton
    >
    <CAlert v-show="notFound && !loading" color="danger">
      Koodia ei löytynyt.
    </CAlert>
    <CCard v-if="code" class="mt-3">
      <CCardBody>
        <template v-if="code.used === 1">
          <h4>
            Koodi <span class="font-monospace">{{ code.code }}</span> on
            käytetty<br /><br />{{ code.updated }}
          </h4>
          <CButton
            color="primary"
            :disabled="loading"
            class="mt-4"
            @click="activateCode()"
            >Aktivoi uudelleen</CButton
          ></template
        >
        <CAlert v-show="Saved && !loading" color="success" class="mb-0">
          <h4 class="m-0">Koodi on nyt aktivoitu uudelleen</h4>
        </CAlert>
        <CAlert
          v-show="!Saved && code.used === 0 && !loading"
          color="success"
          class="mb-0"
        >
          <h4 class="m-0">Koodi on voimassa</h4>
        </CAlert>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
export default {
  name: "Code",
  data() {
    return {
      AskToConfirm: false,
      SavingFailure: false,
      code: null,
      loading: false,
      Saved: false,
      notFound: false,
      id: ""
    };
  },
  props: {
    postId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    Authorized() {
      return (
        this.$store.state.Authorized &&
        "SubscriptionAdmin" in this.$store.state.Authorization === true
      );
    }
  },
  methods: {
    findCode: async function() {
      try {
        if (this.id === "") {
          return;
        }
        this.code = null;
        this.notFound = false;
        this.Saved = false;
        this.loading = true;
        let code = await api.get(
          process.env.VUE_APP_UPSEERIKERHO_API_URL +
            "/code?id=" +
            this.postId +
            this.id
        );

        if (typeof code !== "object") {
          this.loading = false;
          this.notFound = true;
          return;
        }

        code.pageId = parseInt(code.pageId);
        code.used = parseInt(code.used);
        code.printed = parseInt(code.printed);
        code.hash = code.hash ? code.hash : "";
        code.updated = moment(code.updated)
          .clone()
          .format("DD.MM.YYYY HH:mm:ss");
        this.code = { ...code };
        this.loading = false;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    activateCode: async function() {
      try {
        this.loading = true;
        this.Saved = false;
        let saving = await api.post(
          process.env.VUE_APP_UPSEERIKERHO_API_URL + "/codestatus",
          {
            id: this.code.id,
            used: 0
          }
        );
        this.loading = false;
        if (saving !== "success") {
          this.SavingFailure = true;
          return;
        }
        this.code.used = 0;
        this.Saved = true;
        this.loading = false;
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  }
};
</script>
